<template>
  <router-view class="" name="headerlive"></router-view>
  <router-view/>
  <router-view class="" name="footerlive"></router-view>
  <router-view class="" name="stickybottommobilelive"></router-view>
  <router-view class="" name="panelcomptelive"></router-view>
</template>
